import mapboxgl, { Map } from "mapbox-gl";
import { PriceModel } from "../../model/PriceModel";
import MapBox from "../MapBox";
import axios from "axios";
import { useEffect, useMemo, useRef, useState } from "react";
import { Snackbar } from "@mui/material";
import { initPriceLayer, updateSource } from "../../helper/mapDataFeed";
import { Route, Routes, useNavigate } from "react-router-dom";
import { PagePriceMillSelected } from "../PagePriceMillSelected";
import { Param } from "../MainPage";
import { Loader } from "../../component/Loader";

type Props = {
    onPriceAccepted: (price: PriceModel) => void
    page: string
}

export function StepChooseMill({ onPriceAccepted, page }: Props) {

    const [jsonPrices, setJsonPrices] = useState<any>(undefined)
    const [priceSelected, setPriceSelected] = useState<PriceModel | undefined>(undefined)
    const jsonPricesRef = useRef<any>(undefined)
    const mapRef = useRef<Map | undefined>(undefined)

    const userPos = useRef<any | undefined>(undefined)

    const [error, setError] = useState<string | undefined>(undefined)

    const [askPosLoader, setAskPosLoader] = useState<boolean>(false)

    const navigate = useNavigate();

    const allPrices = useMemo(() => jsonPrices ? jsonPrices.features.map((f: any) => PriceModel.buildFromFeature(f.properties, f.geometry)) : [], [jsonPrices])

    useEffect(() => {
        window.gtag("event", "page_view", { page_path: page });
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        if (jsonPrices) {
            updateSource(mapRef.current!, jsonPrices, priceSelected?.id)
        }
        if (priceSelected) {
            flyTo([priceSelected.coordinates!.at(0)!, priceSelected.coordinates!.at(1)!])
        }
        // eslint-disable-next-line
    }, [jsonPrices, priceSelected])

    const flyTo = (coord: number[]) => {
        mapRef.current?.flyTo({
            center: [coord[0], coord[1]],
            essential: true // this animation is considered essential with respect to prefers-reduced-motion
        });
    }

    function askForPosition(onSuccess?: () => void, onError?: () => void) {
        if (!navigator.geolocation) {
            setError('Geolocation is not supported by this browser.');
        } else if (mapRef.current) {
            setAskPosLoader(true)
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    setAskPosLoader(false)
                    const { latitude, longitude } = position.coords;
                    userPos.current = { latitude, longitude }
                    const control = new mapboxgl.GeolocateControl({
                        positionOptions: { enableHighAccuracy: true },
                        trackUserLocation: true,
                        showUserLocation: true,
                        showAccuracyCircle: false,
                        fitBoundsOptions: { center: [userPos.current.longitude, userPos.current.latitude], zoom: mapRef.current?.getZoom() }
                    })
                    control.on('error', (e: any) => {
                        console.log('controle failure', error)
                    })
                    control.on('geolocate', (e: any) => {
                        console.log('controle success', error)
                    })
                    if (mapRef.current?.hasControl(control) === false) {
                        mapRef.current?.addControl(control);
                        setTimeout(() => {
                            control.trigger()
                        }, 1000)
                    }
                    onSuccess?.()
                },
                (err) => {
                    setError(err.message);
                    setAskPosLoader(false)
                    onError?.()
                }
                , {
                    timeout: 7000
                });
        }
    }

    function fetchAllPrices() {
        axios.get(`${process.env.REACT_APP_BASE_URL_PUBLIC}/mapTilingService/priceMVTSourceV2/0/0/0.pbf?cs=facebook`, {
            withCredentials: false,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        }).then((data: any) => {
            jsonPricesRef.current = data.data[0].geoJson
            setJsonPrices(data.data[0].geoJson)
        }).catch(e => {
            if (e?.message) {
                setError(e?.message)
            } else {
                setError('An error occured')
            }
        })
            .finally(() => {
                // setLoading(false)
            })
    }


    function priceAsParam(price: PriceModel): Param[] {
        return [
            { key: "id", value: price.id },
            { key: "price", value: price.pricePerUnit },
            { key: "mill_name", value: price.millName },
            { key: "subdistrict", value: price.subdistrict },
            { key: "village", value: price.village },
        ]
    }

    function onLoaded(map: Map) {
        mapRef.current = map
        initPriceLayer(mapRef.current, jsonPrices, (p: any, g: any) => {
            const price = PriceModel.buildFromFeature(p, g)
            const exParams = priceAsParam(price)
            setPriceSelected(price)
            goToPage(`price_mill_selected`, exParams);
        }, () => {
            fetchAllPrices()
        })
        askForPosition()
    }

    function goToPage(step: string, extraParam?: Param[]) {
        var newParam: string = ''
        // initParam.current.forEach((value: string, key: string) => {
        //     if (newParam.length > 0) {
        //         newParam += '&'
        //     }
        //     newParam += `${key}=${value}`
        // })
        extraParam?.forEach((p: Param) => {
            if (newParam.length > 0) {
                newParam += '&'
            }
            newParam += `${p.key}=${p.value}`
        })
        if (newParam) {
            newParam = '?' + newParam
        }
        // updateInstruction(step)
        if (newParam.length > 0) {
            navigate(`${step}${newParam}`);
        } else {
            navigate(`${step}`);
        }
    }


    return (
        <div style={{ flex: 1, position: "relative", display:"flex", flexDirection:"column" }}>
            <MapBox style={{ width: "100%", flex:1, display:"flex", flexDirection:"column" }} onLoaded={onLoaded} />
            <Routes>
                <Route path="price_mill_selected" element={
                    <PagePriceMillSelected page="landingpage2_price_mill_selected" priceSelected={priceSelected} setPriceSelected={(price: any) => {
                        if (!price) {
                            window.history.back()
                        }
                        setPriceSelected(price)
                    }}
                        onMillPriceAccepted={(p: PriceModel) => {
                            onPriceAccepted(p)
                        }} fetchedPrices={allPrices} />
                } />
            </Routes>
            <Loader isLoading={askPosLoader} />
            <Snackbar
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "center"
                }}
                open={error !== undefined}
                autoHideDuration={6000}
                onClose={() => { setError(undefined) }}
                message={error}
                sx={{
                    '& .MuiSnackbarContent-root': {
                        backgroundColor: "#f00",
                        fontWeight: "600"
                    }
                }}
            />
        </div>
    )
}